module.exports = __webpack_public_path__ + "07.svg?632c0b7c09a3febb7c9f7a19eb03be9e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_setting/07.svg
// module id = 66
// module chunks = 0